export default {
  metrics: {
    pickup: 'Recogida',
    internal_delivery: 'Entrega interna',
    external_delivery: 'Entrega externa',
  },
  events: {
    add_to_basket: 'Añadir artículo',
    begin_checkout: 'Ir al pago',
    begin_purchase: 'Iniciar pago',
    complete_purchase: 'Completar pago',
    order_placed: 'Completar pago',
    view_item: 'Ver artículo',
  },
};
